
export default {
  props: {
    deal: {
      type: Object,
      default: () => ({}),
    },
  },
};
